import React from 'react';
import UserCard from './UserCard';

const EmbudoColumna = ({ column, chats , onCardContextMenu, chatActivoId, onSetActivo, idChatActualizado }) => {
    return (
        <div className="bg-gray-100 rounded-lg w-80 flex-shrink-0 flex flex-col shadow-md">
            <div className="p-3 border-b-2 border-gray-200 sticky top-0 bg-gray-100 rounded-t-lg z-10">
                <h3 className="font-bold text-gray-800 tracking-wide">{column.title}</h3>
                <span className="text-sm text-gray-500 font-medium">{chats.length} chats</span>
            </div>
            <div className="p-2 flex-grow overflow-y-auto">
                {chats.map((chat) => (
                    <UserCard
                        key={chat.phone_number}
                        chat={chat}
                        onContextMenu={onCardContextMenu}

                        chatActivoId={chatActivoId} 
                        onSetActivo={onSetActivo}
                        idChatActualizado={idChatActualizado}
                    />
                ))}
            </div>
        </div>
    );
};

export default EmbudoColumna;